import React from "react";
import PropTypes from "prop-types";
import { Popover } from "antd";

import { IconLight } from "../";

const SelectorInfoPopover = ({ text }) => (
  <Popover title="" trigger={"hover"} content={text} placement={"right"}>
    <span>
      <IconLight
        icon={"info-circle"}
        style={{ color: "#999", marginLeft: "5px" }}
      />
    </span>
  </Popover>
);

SelectorInfoPopover.propTypes = {
  text: PropTypes.string.isRequired
};

export default SelectorInfoPopover;



// WEBPACK FOOTER //
// ./src/views/components/selector_info_popover/SelectorInfoPopover.jsx